// Action Types
export const APP_ACTIONS = {
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  SET_SIDEBAR_STATE: 'SET_SIDEBAR_STATE',
  SHOW_PERMISSION_DENIED: 'SHOW_PERMISSION_DENIED',
  HIDE_PERMISSION_DENIED: 'HIDE_PERMISSION_DENIED'
};

export const toggleSidebar = () => ({
  type: APP_ACTIONS.TOGGLE_SIDEBAR
});

export const setSidebarState = (isOpen) => ({
  type: APP_ACTIONS.SET_SIDEBAR_STATE,
  payload: isOpen
});

export const showPermissionDenied = () => ({
  type: APP_ACTIONS.SHOW_PERMISSION_DENIED
});

export const hidePermissionDenied = () => ({
  type: APP_ACTIONS.HIDE_PERMISSION_DENIED
});
